import React from "react";
import { Link } from "react-router-dom";
import "./MeetingLeftView.css";

function buildDirectRejoinUrl(roomId, displayName) {
  const p = new URLSearchParams();
  if (roomId) p.set("roomid", roomId);
  if (displayName) p.set("name", displayName);
  const q = p.toString();
  return q ? `/livekit/room?${q}` : "/livekit/room";
}

/** Shown after the user leaves a meeting (disconnect). See `MeetingLeftView.d.ts` for props. */
export default function MeetingLeftView({
  roomId,
  displayName,
  onBackToHome,
  /** When still on `/livekit/room` with the same query string, parent must refetch token instead of using <Link> alone. */
  onRejoinSameRoute,
  /**
   * When the leave screen is shown from `/livekit` (session flow), URL is already `/livekit`;
   * a plain <Link to="/livekit"> does not update state. Parent clears `leftMeeting` here.
   */
  onJoinPageClick,
}) {
  const rejoinHref = buildDirectRejoinUrl(roomId, displayName);

  return (
    <div className="meeting-left">
      <div className="meeting-left__card">
        <div className="meeting-left__icon" aria-hidden="true">
          ✓
        </div>
        <h1 className="meeting-left__title">You left the meeting</h1>
        <p className="meeting-left__text">
          Your session has ended. You can join again with the same or a new room.
        </p>
        {roomId && (
          <p className="meeting-left__meta">
            Last room: <strong>{roomId}</strong>
            {displayName ? (
              <>
                {" "}
                · You joined as <strong>{displayName}</strong>
              </>
            ) : null}
          </p>
        )}
        <div className="meeting-left__actions">
          {onRejoinSameRoute ? (
            <button
              type="button"
              className="meeting-left__btn meeting-left__btn--primary"
              onClick={onRejoinSameRoute}
            >
              Rejoin meeting
            </button>
          ) : (
            <Link className="meeting-left__btn meeting-left__btn--primary" to={rejoinHref}>
              Rejoin meeting
            </Link>
          )}
          {onJoinPageClick ? (
            <button
              type="button"
              className="meeting-left__btn meeting-left__btn--secondary"
              onClick={onJoinPageClick}
            >
              Join page
            </button>
          ) : (
            <Link className="meeting-left__btn meeting-left__btn--secondary" to="/livekit">
              Join page
            </Link>
          )}
          {onBackToHome && (
            <button
              type="button"
              className="meeting-left__btn meeting-left__btn--ghost"
              onClick={onBackToHome}
            >
              Dismiss
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
